'use client'

import { page, trackEvent, useAReferrer, useCurrentUrl } from '@patrianna/analytics'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { analyticsConfig } from 'config/analytic'
import { IS_BRAND_PULSZ } from 'config/brands'

export function useAnalyticsPageView() {
  const url = useCurrentUrl(usePathname, useSearchParams)
  const a_referrer = useAReferrer(usePathname, useSearchParams)
  const isFirstLoadRef = useRef(true)
  const tiktokPageViewParams = analyticsConfig.coreConfig.plugins.tiktok.pageView
  const twitterPageViewParams = analyticsConfig.coreConfig.plugins.twitter.pageView

  useEffect(() => {
    const trigger = isFirstLoadRef.current ? 'page_loaded' : 'url_changed'

    if (url.includes('/register') && IS_BRAND_PULSZ) {
      trackEvent(tiktokPageViewParams.register.key, {}, { tiktok: true })
      trackEvent(
        twitterPageViewParams.register.key,
        {
          eventId: twitterPageViewParams.register.key,
          twitterOptions: { description: twitterPageViewParams.register.description },
        },
        { twitter: true },
      )
    }

    if (url.includes('/slots') && IS_BRAND_PULSZ) {
      trackEvent(tiktokPageViewParams.slots.key, {}, { tiktok: true })
      trackEvent(
        twitterPageViewParams.slots.key,
        {
          eventId: twitterPageViewParams.slots.key,
          twitterOptions: { description: twitterPageViewParams.slots.description },
        },
        { twitter: true },
      )
    }

    if (url.includes('home') && IS_BRAND_PULSZ) {
      trackEvent(tiktokPageViewParams.home.key, {}, { tiktok: true })
      trackEvent(
        twitterPageViewParams.home.key,
        {
          eventId: twitterPageViewParams.home.key,
          twitterOptions: { description: twitterPageViewParams.home.description },
        },
        { twitter: true },
      )
    }

    page(
      {
        event: 'custom_pageview',
        c_page_title: document.title,
        c_page_location: url,
        c_page_referrer: a_referrer,
        c_page_trigger: trigger,
      },
      { gtm: true },
    )

    isFirstLoadRef.current = false
  }, [url])
}
